<template>
  <!-- 账号管理 -->
  <div class="account_manage">
    <user-search
      ref="searchBox"
      class="search_box"
      :enterpriseList="enterpriseList"
      @search-change="changeSearch"
      @add-user="add"
    >
    </user-search>
    <user-table
      class="search_table"
      :loading="loading"
      :userList="userList"
      :params="tableParams"
      @change-page="changePage"
      @update="getUserList"
      @edit-user="editUser"
    >
    </user-table>
    <user-modal
      :visible="ifModal"
      :enterpriseList="enterpriseList"
      :edit="edit"
      :initFormData="currentData"
      @close-modal="ifModal = false"
      @update="getUserList"
    >
    </user-modal>
  </div>
</template>

<script>
import userSearch from "./userSearch.vue";
import userTable from "./userTable.vue";
import userModal from "./userModal.vue";
export default {
  name: "AccountManage",
  components: {
    userSearch,
    userTable,
    userModal,
  },
  data() {
    return {
      userList: [], //账号列表
      enterpriseList: [], // 企业列表
      tableParams: {
        // 分页器的参数
        total: 0,
        page: 1,
        size: 10,
      },
      loading: false,
      ifModal: false, // 是否展示modal
      edit: false, // 当前弹窗状态是编辑还是添加
      currentData: {}, // 当前编辑所选的数据
    };
  },
  computed: {},
  mounted() {
    this.getEnterprise();
    this.getUserList();
  },
  methods: {
    // 获取企业列表
    getEnterprise() {
      this.$http({
        url: "/enterprise/listEnterName",
        method: "get",
      })
        .then((res) => {
          if (res.code === 200) {
            this.enterpriseList = res.data || [];
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取企业列表接口请求失败",
            type: "error",
          });
        });
    },
    // 获取账号列表
    getUserList() {
      this.loading = true;
      const data = {
        page: this.tableParams.page,
        size: this.tableParams.size,
        body: this.$refs.searchBox.searchForm,
      };
      this.$http({
        url: "/user/findPage",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.code === 200) {
            this.userList = res.data.list;
            this.tableParams.total = res.data.total;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取账号列表接口请求失败",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 搜索更新
    changeSearch() {
      this.getUserList();
    },
    changePage(page) {
      this.tableParams.page = page;
      this.getUserList();
    },
    // 点击弹窗弹出添加
    add() {
      this.edit = false;
      this.ifModal = true;
    },
    // 点击弹窗弹出编辑
    editUser(row) {
      this.currentData = row;
      this.edit = true;
      this.ifModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.account_manage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_table {
    flex: 1;
    height: 0;
  }
}

// .form {
//   width: 668px;
//   flex-shrink: 0;
// }
// $logo-size: 32px;
// .logo {
//   width: $logo-size;
//   height: $logo-size;
// }
</style>




// WEBPACK FOOTER //
// src/pages/index/views/accManage/index.vue